var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{class:['header', { 'header--fixed': _vm.isFixed }, { 'header--hidden': _vm.isHidden }],attrs:{"id":"header"}},[(_vm.hasTopStripe)?_c('div',{staticClass:"topStripe",class:{ 'topStripe--inverted': _vm.isInverted }},[_c('hot-topbar',_vm._b({},'hot-topbar',_vm.stripeContent,false))],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }